import type { LinkDetail } from '@vividseats/vivid-ui-kit'
import { createSelector } from 'reselect'

import type { PerformerStateType } from '@/context/performer/types'
import type { Performer } from '@/types/app-types'

export const relatedPerformersSelector = createSelector(
    (state: PerformerStateType) => state.data?.items || [],
    (relatedPerformers: Performer[]): Performer[] => relatedPerformers,
)

export const relatedPerformerLinksSelector = createSelector(
    relatedPerformersSelector,
    (relatedPerformers: Performer[]): LinkDetail[] => {
        return relatedPerformers.map(({ id, name, webPath }: Performer) => ({
            id,
            name,
            url: webPath ?? `/performer/${id}`,
        }))
    },
)
